module.exports = __webpack_public_path__ + "img/wifi-off-line.860793cc.svg";